import { LEVEL_NAME_SEPARATOR } from '../constants/levelNameSeparator';

/**
 * Depth 0 keeps the field's own name so the label FormField renders still targets it.
 */
export const getNestedSelectLevelName = (
  name: string,
  depth: number,
): string => (depth === 0 ? name : `${name}${LEVEL_NAME_SEPARATOR}${depth}`);
